<template>
    <div class="page">
        <div v-if="pageType == 0">
            <div class="main-title">{{ refund_type_text }}</div>

            <!-- <div class="refund-step">
            <div class="step-box">
                <div class="step step-1 active">① 买家申请</div>
                <div class="step step-2">② 卖家处理</div>
                <div class="step step-3">③ 售后完成</div>
            </div>
        </div> -->

            <div class="refund-info page-ctx">
                <div class="center">
                    <!-- 商品信息 -->
                    <refundGoodsInfo :order="order" />
                </div>

                <div class="form-wrap">
                    <div class="form-box">
                        <!-- <div class="input-box">
                        <div class="label">服务类型</div>
                        <div class="action">{{ refund_type_text }}</div>
                    </div> -->

                        <div class="input-box">
                            <div class="label">{{ titleFormate }}：<span style="color: #ff3d00">*</span></div>
                            <div class="action">
                                <el-select v-model="reason" placeholder="请选择">
                                    <el-option v-for="item in refundReasonList" :key="item.title" :label="item.title" :value="item.title">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- <div class="input-box shouhuo-box">
                            <div class="label">换货地址</div>
                            <div class="action">
                                <div class="shouhuo">
                                    <div class="rec"><span class="text">收货人: </span> <span class="val"> 222</span></div>
                                    <div class="rec"><span class="text"> 地址:</span> <span class="val">333 </span></div>
                                    <div class="rec"><span class="text"> 手机号码: </span> <span class="val"> 444</span></div>
                                </div>
                            </div>
                        </div> -->

                        <div class="input-box" v-if="refund_type == 1 || refund_type == 2">
                            <div class="label money">退款金额：<span style="color: #ff3d00">*</span></div>
                            <div class="action money">
                                <el-input placeholder="请输入退款金额" onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" v-model="money" />
                                <div class="hintText">
                                    最多￥{{ order.price }}，含运费￥{{ order.payInfo && order.payInfo.yunfei ? order.payInfo.yunfei : '0.00' }}
                                </div>
                            </div>
                        </div>

                        <div class="input-box change" v-else-if="refund_type == 3">
                            <div class="label">换新商品：<span style="color: #ff3d00">*</span></div>
                            <div class="action change">
                                <div class="changeHintText">价格相同的商品才可以换货哦</div>
                                <div class="changeSelectFlexBox">
                                    <div class="leftBox">颜色：</div>
                                    <div class="rightBox">
                                        <div
                                            class="changeBtnBox"
                                            @click="selectChangeProduct(item, index)"
                                            v-for="(item, index) in exchange_products"
                                            :key="index"
                                        >
                                            <img :src="item.image" v-show="index !== exchange_products_index" class="colorImg" alt="" />
                                            <div class="selectActive" v-show="index === exchange_products_index">
                                                <div class="selectBox"></div>
                                            </div>
                                            <div class="text">{{ item.keyVals }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="input-box" v-if="refund_type_text == '退货退款'">
                            <div class="label">
                                {{ currency == '积分' ? '退还积分' : '退款金额(￥)' }}
                            </div>
                            <div class="action">
                                <el-input placeholder="请输入退款金额" v-model="money" />
                            </div>
                        </div> -->

                        <div class="input-box remark-box">
                            <div class="label">{{ titleFormate2 }}：</div>
                            <div class="action">
                                <el-input type="textarea" placeholder="请输入说明信息" v-model="remark" :autosize="{ minRows: 6 }" />
                            </div>
                        </div>
                        <div class="input-box upload-box">
                            <div class="label">上传凭证：</div>
                            <div class="action img">
                                <div class="imgListBox">
                                    <div class="imgItem" v-for="(item, index) in images" :key="index">
                                        <el-image class="elImg" :src="item" :preview-src-list="[item]" :initial-index="0" fit="cover"></el-image>
                                        <div class="delBtn" @click="delImg(index)">
                                            <i class="el-icon-delete icon"></i>
                                        </div>
                                    </div>
                                    <div class="imgItemAdd" @click="uploadBtn" v-show="images.length < 3">
                                        <input type="file" accept="image/*" @change="imgInputChange" class="fileInput" ref="fileInput" />
                                        <i class="el-icon-plus jiaIcon"></i>
                                        <div class="imageHintText">上传凭证</div>
                                        <div class="imageHintText">（最多3张）</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 换货 - 我的地址 -->
                        <div v-if="refund_type == 3 && order.shouhuoInfo">
                            <div class="input-box remark-box">
                                <div class="label">我的地址：</div>
                                <div class="action">
                                    <div class="texts" style="color: #7d7d7d">
                                        {{ order.shouhuoInfo.name }} &nbsp {{ order.shouhuoInfo.phone }}<br />详细地址 &nbsp
                                        {{ order.shouhuoInfo.province }}-{{ order.shouhuoInfo.city }}-{{ order.shouhuoInfo.area }}-{{
                                            order.shouhuoInfo.address
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="submit-box">
                            <button class="btn" @click="submit_refund">提交申请</button>
                        </div>

                        <!-- 退货 -->
                        <div v-if="refund_type == 2">
                            <div class="greyLine"></div>
                            <div class="input-box remark-box">
                                <div class="label">退货方式：</div>
                                <div class="action">
                                    <div class="texts">自行寄回</div>
                                </div>
                            </div>

                            <div class="input-box remark-box" v-if="order.shouhuoInfo && order.shouhuoInfo.name">
                                <div class="label">地址：</div>
                                <div class="action">
                                    <div class="texts" style="color: #7d7d7d">
                                        {{ order.shouhuoInfo.name }} &nbsp {{ order.shouhuoInfo.phone }}<br />详细地址 &nbsp
                                        {{ order.shouhuoInfo.address }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="main-title">申请成功</div>
            <div class="refund-info page-ctx minheig">
                <img src="@/assets/img/common/yes.png" class="yesIcon" alt="" />
                <div class="successText">申请成功</div>
                <div class="successText2">已申请成功，请耐心等待平台审核</div>
                <div class="btnFlexBox">
                    <div class="btn btn-ripple" @click="backStore">返回商城</div>
                    <div class="btn2 btn-ripple" @click="goDetail">查看详情</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import refundGoodsInfo from '@/components/refund/refundGoodsInfo.vue' //
import { UPLOAD_ACTION, UPLOAD_NAME } from '@/config/env.js'
import { mapState } from 'vuex'

export default {
    name: 'refund-submit',
    components: {
        refundGoodsInfo,
    },
    data() {
        return {
            pageType: 0, // 页面状态：0.申请中，1.申请成功
            UPLOAD_ACTION,
            UPLOAD_NAME,
            order_id: this.$route.query.order_id, // 订单id
            inventoryId: this.$route.query.inventoryId, // 商品id
            refund_type: this.$route.query.refund_type, // 售后类型：1.仅退款，2.退货，3.换货

            currency: '',
            orderObj: {},
            order: {},
            product: {},
            exchange_products: [], // 可换货数组
            exchange_products_index: '', // 可换货数组选择下标

            images: [], //评价图片
            reason: '', // 退换原因
            remark: '', // 说明
            money: '', // 退款金额

            //图片预览
            dialogVisible: false,
            dialogImageUrl: '',

            refundReasonList: [], // 售后理由

            maxPrice: 0, // 退款最大金额
            goDetailId: '',
        }
    },
    computed: {
        ...mapState(['']),

        // 退货退款类型
        refund_type_text() {
            let map = {
                1: '仅退款申请',
                2: '退货退款申请',
                3: '换货申请',
            }
            return map[this.refund_type]
        },

        //售后原因
        list_reason_title() {
            return this.webConfig.tuihuan_reason
        },

        //要售后的商品
        refund_goods() {
            let obj = {}
            if (this.order && this.order.products) {
                obj = this.order.products.find((v) => v.id == this.inventoryId)
            }
            return obj
        },

        //退款金额
        refundMoney() {
            if (this.currency == '积分') {
                return (this.orderObj.pay_info && this.orderObj.pay_info.jifen) || 0
            } else {
                let money = this.refund_goods.priceSale * this.refund_goods.num

                return money || 0
            }
        },

        // 标题文案
        titleFormate() {
            let refund_type = this.refund_type
            if (refund_type == 1) {
                return '退款原因'
            } else if (refund_type == 2) {
                return '退款原因'
            } else if (refund_type == 3) {
                return '换货原因'
            }
        },

        // 标题文案2
        titleFormate2() {
            let refund_type = this.refund_type
            if (refund_type == 1) {
                return '退款说明'
            } else if (refund_type == 2) {
                return '退款说明'
            } else if (refund_type == 3) {
                return '换货说明'
            }
        },
    },
    created() {
        this.refundReason()
        this.setView()
    },
    methods: {
        // 选择换货的商品
        selectChangeProduct(item, index) {
            if (item.isChangeOk == 0) {
                alertErr('不支持更换此商品')
                return
            }
            this.exchange_products_index = index
        },
        refundReason() {
            this.$api('refund_reason', {}).then((res) => {
                let { code, data, msg } = res
                if (code == 200) {
                    this.refundReasonList = res.data
                } else {
                }
            })
        },
        setView() {
            this.$api('orders_detail', {
                id: this.order_id,
            }).then((res) => {
                let { code, data, msg } = res
                if (code == 200) {
                    this.order = data
                    this.orderObj = data
                    this.product = data.products.find((v) => v.id == this.inventoryId)
                    this.maxPrice = parseFloat(data.price)

                    if (this.refund_type == 3) {
                        let priceSale = Number(this.product.priceOld) / Number(this.product.num)
                        // 换货
                        this.$api('refund_showChangeProduct', {
                            inventoryId: this.inventoryId,
                            productId: this.product.productId,
                            num: this.product.num,
                            priceSale: priceSale.toFixed(2),
                        }).then((res) => {
                            let { code, data, msg } = res
                            if (code == 200) {
                                this.exchange_products = data
                            }
                        })
                    }
                }
            })
        },

        //提交评价
        submit_refund() {
            let { reason, remark, money } = this

            if (!reason) {
                alertErr('请选择售后原因')
                return
            }

            if (money == '' && (this.refund_type == 1 || this.refund_type == 2)) {
                alertErr('请输入退款金额')
                return
            }

            if (Number(money) > this.maxPrice && (this.refund_type == 1 || this.refund_type == 2)) {
                alertErr('退款金额不应高于' + this.maxPrice + '元')
                return
            }

            let urlArrStr = ''
            if (this.images) {
                urlArrStr = this.images.join(',')
            }

            //退换货类型(1-退款   2-退货退款  3-换货)
            let params = {
                orderId: this.order_id,
                inventoryId: this.inventoryId,
                type: this.refund_type,
                num: this.refund_goods.num,

                reason: this.reason,
                remark: this.remark,
                images: urlArrStr,
                money: this.money,
            }

            // 换货
            if (this.refund_type == 3 && this.exchange_products_index == '') {
                alertErr('请选择换新商品')
                return
            }

            // 换货
            if (this.refund_type == 3) {
                this.exchange_products[this.exchange_products_index].inventoryId = this.exchange_products[this.exchange_products_index].id
                params['new_product'] = this.exchange_products[this.exchange_products_index]
                params['new_product']['num'] = params.num
                params['addressId'] = this.orderObj.shouhuoInfo.id
            }

            this.$load.open()
            this.$api('refund_add', params).then((res) => {
                this.$load.close()
                let { code, msg, data } = res
                if (code == 200) {
                    this.pageType = 1
                    this.goDetailId = data.id
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth',
                    })
                } else {
                    alertErr(res.msg)
                }
            })
        },

        // 图片上传
        uploadBtn() {
            this.$refs.fileInput.click()
        },

        async imgInputChange() {
            const file = this.$refs['fileInput'].files[0]
            const fileName = file.name // 文件名字
            const index = file.name.lastIndexOf('.')
            const ext = file.name.substr(index + 1) // 文件类型
            const size = file.size / 1024 / 1024 // 文件大小（单位：MB）
            this.$load.open()
            let res = await this.$uploadFile(file)
            this.$load.close()
            if (res) {
                this.images.push(res)
            } else {
                alert('上传失败')
            }
            this.$refs['fileInput'].value = ''
        },

        // 删除图片
        delImg(index) {
            this.images.splice(index, 1)
        },

        backStore() {
            this.$router.push('/')
        },
        // 去售后详情
        goDetail() {
            this.$router.push({
                path: '/refund-service-detail',
                query: {
                    refund_id: this.goDetailId,
                },
            })
        },
    },
}
</script>

<style scoped lang="less">
/deep/ .order-list-wrap {
    margin-top: 30px;
}
/deep/ .info-heji {
    display: none !important;
}

.page {
    padding-bottom: 50px;

    .main-title {
        margin-bottom: 12px;
        padding: 0 32px;
        text-align: left;
        height: 56px;
        line-height: 56px;
        background: #ffffff;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
    }

    .page-ctx {
        padding: 44px 48px;
        background: #fff;
    }

    .minheig {
        min-height: 600px;
    }

    .yesIcon {
        width: 60px;
        display: block;
        margin: 0 auto;
    }

    .successText {
        margin-top: 20px;
        text-align: center;
        width: 100%;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        line-height: 16px;
    }

    .successText2 {
        margin-top: 20px;
        text-align: center;
        width: 100%;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 14px;
    }

    .btnFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 60px;

        .btn {
            width: 170px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            margin-right: 20px;
            font-size: 14px;
            color: #7d7d7d;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
        }

        .btn2 {
            width: 170px;
            height: 40px;
            background: #ff4d00;
            border-radius: 0px 0px 0px 0px;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
        }
    }
}

.refund-step {
    .step-box {
        width: 100%;
        margin: 0 auto;
        font-size: 14px;
        .flex();
        .step {
            flex: 1;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #eee;
            cursor: pointer;
            transition: 0.3s;
            &:hover {
                opacity: 0.75;
            }

            &.step-1 {
                clip-path: polygon(0% 0%, 97% 0%, 100% 50%, 97% 100%, 0% 100%);
            }
            &.step-2 {
                clip-path: polygon(0% 0%, 97% 0%, 100% 50%, 97% 100%, 0% 100%, 3% 50%);
            }
            &.step-3 {
                // clip-path: polygon(0% 0%, 97% 0%, 100% 50%, 97% 100%, 0% 100%, 3% 50%);
                clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%, 3% 50%);
            }

            &.active {
                background: #ff4d00;
                color: #fff;
            }
        }
    }
}

.refund-info {
}

.form-wrap {
    width: 100%;
    text-align: left;

    .greyLine {
        width: calc(100% + 48px + 48px);
        height: 1px;
        background: #ebebeb;
        overflow: hidden;
        margin-left: -48px;
        margin-top: 34px;
        margin-bottom: 28px;
    }

    .input-box {
        width: 100%;
        margin-bottom: 25px;
        .flex();

        &.shouhuo-box {
            align-items: flex-start;
        }

        &.remark-box {
            align-items: flex-start;
        }

        &.upload-box {
            align-items: flex-start;
        }

        &.change {
            align-items: flex-start;
        }

        .label {
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 30px;

            &.money {
                position: relative;
                top: -12px;
            }
        }

        .action {
            width: 455px;
            margin-left: 14px;

            &.change {
                width: 600px;
            }

            .changeHintText {
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 30px;
                margin-bottom: 33px;
            }

            .changeSelectFlexBox {
                width: 100%;
                display: flex;
                align-items: flex-start;
                justify-content: space-between;

                .leftBox {
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    line-height: 18px;
                    width: 68px;
                }

                .rightBox {
                    width: calc(100% - 68px);
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-start;
                    flex-wrap: wrap;

                    .changeBtnBox {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 30px;
                        margin-bottom: 10px;
                        cursor: pointer;

                        .colorImg {
                            width: 18px;
                            height: 18px;
                            margin-right: 10px;
                            border-radius: 50%;
                        }

                        .selectActive {
                            margin-right: 10px;
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 1px solid #000000;

                            .selectBox {
                                width: 12px;
                                height: 12px;
                                background: #ff4d00;
                                border-radius: 50%;
                            }
                        }

                        .text {
                            font-weight: 400;
                            font-size: 14px;
                            color: #555555;
                            line-height: 14px;
                        }
                    }
                }
            }

            &.money {
                /deep/ .el-input__inner {
                    color: #ff0000;
                }
            }

            &.img {
                width: auto;
            }

            .imgListBox {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .imgItem {
                    width: 120px;
                    height: 120px;
                    margin-right: 20px;
                    border: 1px solid #9f9f9f;
                    cursor: pointer;
                    position: relative;

                    &:hover {
                        .delBtn {
                            display: flex;
                        }
                    }

                    .delBtn {
                        width: 100%;
                        height: 100%;
                        display: none;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 9;
                        background: rgba(0, 0, 0, 0.6);

                        .icon {
                            color: #ffffff;
                            font-size: 20px;
                            line-height: 20px;
                        }
                    }

                    .elImg {
                        width: 100%;
                        height: 100%;
                    }
                }

                .imgItemAdd {
                    width: 120px;
                    height: 120px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    background: #ffffff;
                    border: 1px solid #9f9f9f;
                    cursor: pointer;

                    .fileInput {
                        position: fixed;
                        top: 1000000px;
                        left: 1000000px;
                    }

                    .jiaIcon {
                        font-size: 30px;
                        line-height: 30px;
                        margin-bottom: 10px;
                        color: #999999;
                    }

                    .imageHintText {
                        width: 100%;
                        text-align: center;
                        font-size: 14px;
                        line-height: 14px;
                        color: #999999;
                        margin-bottom: 10px;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .el-input {
                width: 100%;
            }

            .el-select {
                width: 100%;
            }

            .texts {
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 30px;
            }

            .hintText {
                font-weight: 400;
                font-size: 12px;
                color: #999999;
                line-height: 12px;
                margin-top: 10px;
            }

            .imageUploadHintBox {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background: #ffffff;

                .jiaIcon {
                    width: 46px;
                    margin-bottom: 10px;
                }

                .imageHintText {
                    width: 100%;
                    text-align: center;
                    font-size: 18px;
                    line-height: 18px;
                    color: #999999;
                    margin-bottom: 10px;
                }
            }

            .shouhuo {
                .rec {
                    .flex();

                    .text {
                        min-width: 75px;
                    }
                    .val {
                    }
                }
            }
        }
    }

    .submit-box {
        margin-top: 40px;
        padding-left: 120px;
        .btn {
            width: 240px;
            height: 40px;
            background: linear-gradient(90deg, #ff9312 0%, #eb5d53 100%);
            background: #ff4d00;
            border-radius: 30px;
            border-radius: 0;

            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 36px;
            color: #ffffff;
        }
    }
}
</style>
